import { render, staticRenderFns } from "./printers.vue?vue&type=template&id=96fec94e&scoped=true&"
import script from "./printers.vue?vue&type=script&lang=js&"
export * from "./printers.vue?vue&type=script&lang=js&"
import style0 from "./printers.vue?vue&type=style&index=0&id=96fec94e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fec94e",
  null
  
)

export default component.exports